// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Splitter Component */
:host {
  visibility: hidden;
}

:host(.ids-splitter-initialized) {
  visibility: visible;
}

:host([text-wrap]) * {
  white-space: normal;
}

.ids-splitter {
  display: flex;
  position: relative;
  height: 100%;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}
.ids-splitter.axis-x {
  flex-direction: row;
}
.ids-splitter.axis-y {
  flex-direction: column;
}
.ids-splitter.axis-y .splitter-dragger .splitter-expand-btn {
  top: -12px;
  right: auto;
  left: 50%;
  transform: translateX(-50%);
}
.ids-splitter.axis-y .splitter-dragger .splitter-expand-btn::before {
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-top: 4px solid var(--ids-splitter-expand-btn-arrow-color);
  border-bottom: none;
}
.ids-splitter.axis-y .splitter-dragger .splitter-expand-btn:hover::before {
  border-top-color: var(--ids-splitter-expand-btn-hover-arrow-color);
}
.ids-splitter .splitter-drag-handle {
  background-color: var(--ids-splitter-handle-color-background-hover);
  border-radius: var(--ids-splitter-handle-border-radius);
  display: block;
  height: var(--ids-splitter-handle-height);
  opacity: 0;
  position: absolute;
  margin-inline-start: -3px;
  width: var(--ids-splitter-handle-width);
  z-index: 1;
}
.ids-splitter .splitter-dragger {
  position: absolute;
}
.ids-splitter .splitter-dragger .split-bar {
  border-inline-start: 1px solid var(--ids-splitter-bar-color-border);
  display: flex;
  position: relative;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
}
.ids-splitter .splitter-dragger .split-bar:hover {
  border-inline-start: 2px solid var(--ids-splitter-bar-color-border-hover);
}
.ids-splitter .splitter-dragger .split-bar:hover .splitter-drag-handle {
  opacity: 1;
}
.ids-splitter .splitter-dragger .split-bar::before {
  content: "";
  position: absolute;
  height: 100%;
  margin-inline-start: -4px;
  width: var(--ids-splitter-bar-buffer-width);
}
.ids-splitter .splitter-dragger[axis=x] {
  height: 100%;
  top: 0;
  z-index: 3;
}
.ids-splitter .splitter-dragger[axis=x] .split-bar {
  width: var(--ids-splitter-bar-width);
}
.ids-splitter .splitter-dragger[axis=y] {
  left: 0;
  width: 100%;
  z-index: 3;
}
.ids-splitter .splitter-dragger[axis=y] .split-bar {
  border-block-start: 1px solid var(--ids-splitter-bar-color-border);
  border-inline-start: 0;
  height: var(--ids-splitter-bar-width);
}
.ids-splitter .splitter-dragger[axis=y] .split-bar::before {
  height: var(--ids-splitter-bar-buffer-width);
  margin-inline-start: 0;
  margin-block-start: -2px;
  width: 100%;
  z-index: -1;
}
.ids-splitter .splitter-dragger[axis=y] .split-bar:hover {
  border-block-start: 2px solid var(--ids-splitter-bar-color-border-hover);
}
.ids-splitter .splitter-dragger[axis=y][is-dragging] .split-bar, .ids-splitter .splitter-dragger[axis=y]:focus .split-bar {
  border-inline-start: 0;
  border-block-start: 2px solid var(--ids-splitter-bar-color-border-dragging);
}
.ids-splitter .splitter-dragger[axis=y] .splitter-drag-handle {
  margin-block-start: -4px;
  margin-inline-start: 0;
  height: var(--ids-splitter-handle-width);
  width: var(--ids-splitter-handle-height);
}
.ids-splitter .splitter-dragger[is-dragging], .ids-splitter .splitter-dragger:focus {
  outline: none;
}
.ids-splitter .splitter-dragger[is-dragging] .split-bar, .ids-splitter .splitter-dragger:focus .split-bar {
  border-inline-start: 2px solid var(--ids-splitter-bar-color-border-dragging);
}
.ids-splitter .splitter-dragger[is-dragging] .splitter-drag-handle, .ids-splitter .splitter-dragger:focus .splitter-drag-handle {
  opacity: 1;
}
.ids-splitter .splitter-dragger[disabled] {
  display: none;
}
.ids-splitter .splitter-dragger:hover .splitter-expand-btn, .ids-splitter .splitter-dragger.touch-active .splitter-expand-btn {
  opacity: 1;
  visibility: visible;
}
.ids-splitter .splitter-dragger .splitter-expand-btn {
  position: absolute;
  top: 16px;
  width: 24px;
  height: 24px;
  background: var(--ids-splitter-expand-btn-background-color);
  border: 1px solid var(--ids-splitter-expand-btn-border-color);
  border-radius: 8px;
  cursor: pointer;
  z-index: 102;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--ids-splitter-expand-btn-shadow);
  transition: opacity 0.2s ease, transform 0.3s ease;
  opacity: 0;
  visibility: hidden;
  right: -12px;
}
.ids-splitter .splitter-dragger .splitter-expand-btn::before {
  content: "";
  width: 0;
  height: 0;
  border-left: 4px solid var(--ids-splitter-expand-btn-arrow-color);
  border-top: 3px solid var(--ids-splitter-expand-btn-arrow-transparent);
  border-bottom: 3px solid var(--ids-splitter-expand-btn-arrow-transparent);
  transform: rotate(180deg);
}
.ids-splitter .splitter-dragger .splitter-expand-btn:hover {
  background: var(--ids-splitter-expand-btn-hover-background-color);
  border-color: var(--ids-splitter-expand-btn-hover-border-color);
  box-shadow: var(--ids-splitter-expand-btn-hover-shadow);
}
.ids-splitter .splitter-dragger .splitter-expand-btn.is-collapsed {
  opacity: 1;
  visibility: visible;
  inset-inline-end: -12px;
  border: 1px solid var(--ids-splitter-expand-btn-border-color);
  box-shadow: var(--ids-splitter-expand-btn-shadow);
  z-index: 1001;
  background-color: var(--ids-splitter-expand-btn-background-color);
}
.ids-splitter .splitter-dragger .splitter-expand-btn.is-collapsed::after {
  content: "";
  position: absolute;
  left: -2px;
  top: 0;
  width: 2px;
  height: 100%;
}
.ids-splitter .splitter-dragger .splitter-expand-btn[data-collapsed=false]::before {
  transform: rotate(180deg);
}
.ids-splitter .splitter-dragger .splitter-expand-btn[data-collapsed=true]::before {
  transform: rotate(0deg);
}

:host(.rtl) .ids-splitter.axis-y .splitter-dragger .splitter-expand-btn {
  top: -16px;
  right: auto;
  left: 50%;
  transform: translateX(-50%);
}
:host(.rtl) .ids-splitter.axis-y .splitter-dragger .splitter-expand-btn::before {
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-top: 4px solid var(--ids-splitter-expand-btn-arrow-color);
  border-bottom: none;
}
:host(.rtl) .ids-splitter.axis-y .splitter-dragger .splitter-expand-btn.is-collapsed::before {
  transform: rotate(180deg);
}
:host(.rtl) .ids-splitter.axis-y .splitter-dragger .splitter-expand-btn:hover::before {
  border-top-color: var(--ids-splitter-expand-btn-hover-arrow-color);
}

:host(.rtl) .splitter-dragger .splitter-expand-btn {
  right: auto;
  left: -12px;
}
:host(.rtl) .splitter-dragger .splitter-expand-btn::before {
  border-left: none;
  border-right: 4px solid var(--ids-splitter-expand-btn-arrow-color);
  border-top: 3px solid var(--ids-splitter-expand-btn-arrow-transparent);
  border-bottom: 3px solid var(--ids-splitter-expand-btn-arrow-transparent);
  transform: rotate(0deg);
}
:host(.rtl) .splitter-dragger .splitter-expand-btn:hover::before {
  border-right-color: var(--ids-splitter-expand-btn-hover-arrow-color);
}
:host(.rtl) .splitter-dragger .splitter-expand-btn.is-collapsed {
  left: -12px;
  background-color: var(--ids-splitter-expand-btn-background-color);
  border: 1px solid var(--ids-splitter-expand-btn-border-color);
  box-shadow: var(--ids-splitter-expand-btn-shadow);
  z-index: 1001;
}
:host(.rtl) .splitter-dragger .splitter-expand-btn.is-collapsed::after {
  content: "";
  position: absolute;
  right: -2px;
  top: 0;
  width: 2px;
  height: 100%;
}
:host(.rtl) .splitter-dragger .splitter-expand-btn[data-collapsed=true]::before {
  transform: rotate(0deg);
}
:host(.rtl) .splitter-dragger .splitter-expand-btn[data-collapsed=false]::before {
  transform: rotate(180deg);
}

:host(.is-collapsed) .splitter-dragger .splitter-expand-btn,
:host([data-collapsed=true]) .splitter-dragger .splitter-expand-btn {
  opacity: 1;
  visibility: visible;
  z-index: 1001;
}

.collapsed-edge-hover-area {
  position: absolute;
  top: 0;
  right: 0;
  width: 6px;
  height: 100%;
  z-index: 999;
  cursor: ew-resize;
}
.collapsed-edge-hover-area:hover .splitter-expand-btn {
  opacity: 1;
  visibility: visible;
  right: -22px;
}

:host(.rtl) .collapsed-edge-hover-area {
  right: auto;
  left: 0;
}
:host(.rtl) .collapsed-edge-hover-area .ids-splitter-pane {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-splitter/ids-splitter.scss"],"names":[],"mappings":"AAEA,2BAAA;AACA;EACE,kBAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAME;EACE,mBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AAJF;AAME;EACE,mBAAA;AAJJ;AAOE;EACE,sBAAA;AALJ;AASM;EACE,UAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;AAPR;AASQ;EACE,kCAAA;EACA,mCAAA;EACA,gEAAA;EACA,mBAAA;AAPV;AAUQ;EACE,kEAAA;AARV;AAcE;EACE,mEAAA;EACA,uDAAA;EACA,cAAA;EACA,yCAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,uCAAA;EACA,UAAA;AAZJ;AAeE;EACE,kBAAA;AAbJ;AAeI;EACE,mEAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AAbN;AAeM;EACE,yEAAA;AAbR;AAeQ;EACE,UAAA;AAbV;AAiBM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,2CAAA;AAfR;AAmBI;EACE,YAAA;EACA,MAAA;EACA,UAAA;AAjBN;AAmBM;EACE,oCAAA;AAjBR;AAqBI;EACE,OAAA;EACA,WAAA;EACA,UAAA;AAnBN;AAqBM;EACE,kEAAA;EACA,sBAAA;EACA,qCAAA;AAnBR;AAqBQ;EACE,4CAAA;EACA,sBAAA;EACA,wBAAA;EACA,WAAA;EACA,WAAA;AAnBV;AAsBQ;EACE,wEAAA;AApBV;AA0BQ;EACE,sBAAA;EACA,2EAAA;AAxBV;AA4BM;EACE,wBAAA;EACA,sBAAA;EACA,wCAAA;EACA,wCAAA;AA1BR;AA8BI;EAEE,aAAA;AA7BN;AA+BM;EACE,4EAAA;AA7BR;AAgCM;EACE,UAAA;AA9BR;AAkCI;EACE,aAAA;AAhCN;AAmCI;EAEE,UAAA;EACA,mBAAA;AAlCN;AAqCI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,2DAAA;EACA,6DAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iDAAA;EACA,kDAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;AAnCN;AAqCM;EACE,WAAA;EACA,QAAA;EACA,SAAA;EACA,iEAAA;EACA,sEAAA;EACA,yEAAA;EACA,yBAAA;AAnCR;AAsCM;EACE,iEAAA;EACA,+DAAA;EACA,uDAAA;AApCR;AAuCM;EACE,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,6DAAA;EACA,iDAAA;EACA,aAAA;EACA,iEAAA;AArCR;AAuCQ;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;AArCV;AA0CM;EACE,yBAAA;AAxCR;AA2CM;EACE,uBAAA;AAzCR;;AAgDE;EACE,UAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;AA7CJ;AA+CI;EACE,kCAAA;EACA,mCAAA;EACA,gEAAA;EACA,mBAAA;AA7CN;AAgDI;EACE,yBAAA;AA9CN;AAiDI;EACE,kEAAA;AA/CN;;AAoDE;EACE,WAAA;EACA,WAAA;AAjDJ;AAmDI;EACE,iBAAA;EACA,kEAAA;EACA,sEAAA;EACA,yEAAA;EACA,uBAAA;AAjDN;AAoDI;EACE,oEAAA;AAlDN;AAqDI;EACE,WAAA;EACA,iEAAA;EACA,6DAAA;EACA,iDAAA;EACA,aAAA;AAnDN;AAqDM;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;AAnDR;AAwDI;EACE,uBAAA;AAtDN;AAyDI;EACE,yBAAA;AAvDN;;AA4DI;;EAEE,UAAA;EACA,mBAAA;EACA,aAAA;AAzDN;;AA4DI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AAzDN;AA2DM;EACE,UAAA;EACA,mBAAA;EACA,YAAA;AAzDR;;AA8DI;EACE,WAAA;EACA,OAAA;AA3DN;AA6DI;EACE,gBAAA;AA3DN","sourcesContent":["@use '../../themes/mixins/ids-core-mixins' as *;\n\n/* Ids Splitter Component */\n:host {\n  visibility: hidden; // Fix FOUC\n}\n\n:host(.ids-splitter-initialized) {\n  visibility: visible;\n}\n\n// Allow text content to wrap normally\n:host([text-wrap]) {\n  * {\n    white-space: normal;\n  }\n}\n\n.ids-splitter {\n  display: flex;\n  position: relative;\n  height: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 100%;\n\n  &.axis-x {\n    flex-direction: row;\n  }\n\n  &.axis-y {\n    flex-direction: column;\n\n    // Vertical splitter expand button positioning\n    .splitter-dragger {\n      .splitter-expand-btn {\n        top: -12px;\n        right: auto;\n        left: 50%;\n        transform: translateX(-50%);\n\n        &::before {\n          border-left: 3px solid transparent;\n          border-right: 3px solid transparent;\n          border-top: 4px solid var(--ids-splitter-expand-btn-arrow-color);\n          border-bottom: none;\n        }\n\n        &:hover::before {\n          border-top-color: var(--ids-splitter-expand-btn-hover-arrow-color);\n        }\n      }\n    }\n  }\n\n  .splitter-drag-handle {\n    background-color: var(--ids-splitter-handle-color-background-hover);\n    border-radius: var(--ids-splitter-handle-border-radius);\n    display: block;\n    height: var(--ids-splitter-handle-height);\n    opacity: 0;\n    position: absolute;\n    margin-inline-start: -3px;\n    width: var(--ids-splitter-handle-width);\n    z-index: 1;\n  }\n\n  .splitter-dragger {\n    position: absolute;\n\n    .split-bar {\n      border-inline-start: 1px solid var(--ids-splitter-bar-color-border);\n      display: flex;\n      position: relative;\n      height: 100%;\n      width: 100%;\n      align-items: center;\n      justify-content: center;\n\n      &:hover {\n        border-inline-start: 2px solid var(--ids-splitter-bar-color-border-hover);\n\n        .splitter-drag-handle  {\n          opacity: 1;\n        }\n      }\n\n      &::before {\n        content: '';\n        position: absolute;\n        height: 100%;\n        margin-inline-start: -4px;\n        width: var(--ids-splitter-bar-buffer-width);\n      }\n    }\n\n    &[axis='x'] {\n      height: 100%;\n      top: 0;\n      z-index: 3;\n\n      .split-bar {\n        width: var(--ids-splitter-bar-width);\n      }\n    }\n\n    &[axis='y'] {\n      left: 0;\n      width: 100%;\n      z-index: 3;\n\n      .split-bar {\n        border-block-start: 1px solid var(--ids-splitter-bar-color-border);\n        border-inline-start: 0;\n        height: var(--ids-splitter-bar-width);\n\n        &::before {\n          height: var(--ids-splitter-bar-buffer-width);\n          margin-inline-start: 0;\n          margin-block-start: -2px;\n          width: 100%;\n          z-index: -1;\n        }\n\n        &:hover {\n          border-block-start: 2px solid var(--ids-splitter-bar-color-border-hover);\n        }\n      }\n\n      &[is-dragging],\n      &:focus {\n        .split-bar {\n          border-inline-start: 0;\n          border-block-start: 2px solid var(--ids-splitter-bar-color-border-dragging);\n        }\n      }\n\n      .splitter-drag-handle {\n        margin-block-start: -4px;\n        margin-inline-start: 0;\n        height: var(--ids-splitter-handle-width);\n        width: var(--ids-splitter-handle-height);\n      }\n    }\n\n    &[is-dragging],\n    &:focus {\n      outline: none;\n\n      .split-bar {\n        border-inline-start: 2px solid var(--ids-splitter-bar-color-border-dragging);\n      }\n\n      .splitter-drag-handle  {\n        opacity: 1;\n      }\n    }\n\n    &[disabled] {\n      display: none;\n    }\n\n    &:hover .splitter-expand-btn,\n    &.touch-active .splitter-expand-btn {\n      opacity: 1;\n      visibility: visible;\n    }\n\n    .splitter-expand-btn {\n      position: absolute;\n      top: 16px;\n      width: 24px;\n      height: 24px;\n      background: var(--ids-splitter-expand-btn-background-color);\n      border: 1px solid var(--ids-splitter-expand-btn-border-color);\n      border-radius: 8px;\n      cursor: pointer;\n      z-index: 102;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      box-shadow: var(--ids-splitter-expand-btn-shadow);\n      transition: opacity 0.2s ease, transform 0.3s ease;\n      opacity: 0;\n      visibility: hidden;\n      right: -12px;\n\n      &::before {\n        content: '';\n        width: 0;\n        height: 0;\n        border-left: 4px solid var(--ids-splitter-expand-btn-arrow-color);\n        border-top: 3px solid var(--ids-splitter-expand-btn-arrow-transparent);\n        border-bottom: 3px solid var(--ids-splitter-expand-btn-arrow-transparent);\n        transform: rotate(180deg); // Default LTR: point left to collapse\n      }\n\n      &:hover {\n        background: var(--ids-splitter-expand-btn-hover-background-color);\n        border-color: var(--ids-splitter-expand-btn-hover-border-color);\n        box-shadow: var(--ids-splitter-expand-btn-hover-shadow);\n      }\n\n      &.is-collapsed {\n        opacity: 1;\n        visibility: visible;\n        inset-inline-end: -12px;\n        border: 1px solid var(--ids-splitter-expand-btn-border-color);\n        box-shadow: var(--ids-splitter-expand-btn-shadow);\n        z-index: 1001;\n        background-color: var(--ids-splitter-expand-btn-background-color);\n\n        &::after {\n          content: '';\n          position: absolute;\n          left: -2px;\n          top: 0;\n          width: 2px;\n          height: 100%;\n        }\n      }\n\n      // Icon rotation based on collapsed state - point where it will go\n      &[data-collapsed='false']::before {\n        transform: rotate(180deg); // Point left to collapse (panel goes left)\n      }\n\n      &[data-collapsed='true']::before {\n        transform: rotate(0deg); // Point right to expand (panel comes back right)\n      }\n    }\n  }\n}\n\n  // RTL vertical splitter expand button positioning\n  :host(.rtl) .ids-splitter.axis-y .splitter-dragger .splitter-expand-btn {\n    top: -16px;\n    right: auto;\n    left: 50%;\n    transform: translateX(-50%);\n\n    &::before {\n      border-left: 3px solid transparent;\n      border-right: 3px solid transparent;\n      border-top: 4px solid var(--ids-splitter-expand-btn-arrow-color);\n      border-bottom: none;\n    }\n\n    &.is-collapsed::before {\n      transform: rotate(180deg);\n    }\n\n    &:hover::before {\n      border-top-color: var(--ids-splitter-expand-btn-hover-arrow-color);\n    }\n  }\n\n  // RTL positioning for expand button\n  :host(.rtl) .splitter-dragger .splitter-expand-btn {\n    right: auto;\n    left: -12px;\n\n    &::before {\n      border-left: none;\n      border-right: 4px solid var(--ids-splitter-expand-btn-arrow-color);\n      border-top: 3px solid var(--ids-splitter-expand-btn-arrow-transparent);\n      border-bottom: 3px solid var(--ids-splitter-expand-btn-arrow-transparent);\n      transform: rotate(0deg); // Default RTL: point right to collapse\n    }\n\n    &:hover::before {\n      border-right-color: var(--ids-splitter-expand-btn-hover-arrow-color);\n    }\n\n    &.is-collapsed {\n      left: -12px;\n      background-color: var(--ids-splitter-expand-btn-background-color);\n      border: 1px solid var(--ids-splitter-expand-btn-border-color);\n      box-shadow: var(--ids-splitter-expand-btn-shadow);\n      z-index: 1001;\n\n      &::after {\n        content: '';\n        position: absolute;\n        right: -2px;\n        top: 0;\n        width: 2px;\n        height: 100%;\n      }\n    }\n\n    // RTL arrow directions\n    &[data-collapsed='true']::before {\n      transform: rotate(0deg);\n    }\n\n    &[data-collapsed='false']::before {\n      transform: rotate(180deg);\n    }\n  }\n\n    // Collapsed pane detection and expand button visibility\n    :host(.is-collapsed) .splitter-dragger .splitter-expand-btn,\n    :host([data-collapsed='true']) .splitter-dragger .splitter-expand-btn {\n      opacity: 1;\n      visibility: visible;\n      z-index: 1001;\n    }\n\n    .collapsed-edge-hover-area {\n      position: absolute;\n      top: 0;\n      right: 0;\n      width: 6px;\n      height: 100%;\n      z-index: 999;\n      cursor: ew-resize;\n\n      &:hover .splitter-expand-btn {\n        opacity: 1;\n        visibility: visible;\n        right: -22px;\n      }\n    }\n\n    // RTL collapsed edge hover area\n    :host(.rtl) .collapsed-edge-hover-area {\n      right: auto;\n      left: 0;\n\n    .ids-splitter-pane {\n      overflow: hidden;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
